import React, {useEffect, useState} from "react";
import "./Legend.css";
import {FilterSettings} from "./Home";
import chargingStationMarker from "../resources/icons/chargingStationMarker.svg";
import {ControlPosition, MapControl} from "@vis.gl/react-google-maps";

function Legend(props: {
  filterSettings: {
    get: FilterSettings;
    set: React.Dispatch<React.SetStateAction<FilterSettings>>;
  };
  constructionRequestFinished: boolean;
  chargingRequestFinished: boolean;
  wifiRequestFinished: boolean;
  kiosk?: boolean;
}) {
  const [ac, setAc] = useState(
    ["AC", "Beides"].includes(props.filterSettings.get.powerType),
  );
  const [dc, setDc] = useState(
    ["DC", "Beides"].includes(props.filterSettings.get.powerType),
  );

  useEffect(() => {
    props.filterSettings.set((old) => ({
      ...old,
      powerType: ac && dc ? "Beides" : ac ? "AC" : dc ? "DC" : "Beides",
    }));
  }, [ac, dc]);

  return (
    <MapControl position={ControlPosition.BOTTOM_CENTER}>
      <div className={"legend" + (props.kiosk ? " legend--kiosk" : "")}>
        <div className="legend__column">
          <div className="legend__heading">
            <span>Ladesäulen</span>
            <img
              src={chargingStationMarker}
              alt="Ladesäulen"
              height={16}
              width={16}
            />
          </div>
          <div className="legend__controls">
            <CheckboxIndicator
              label="AC"
              checked={ac}
              setChecked={(newValue) => setAc(newValue)}
              disabled={!props.chargingRequestFinished}
            />
            <CheckboxIndicator
              label="DC"
              checked={dc}
              setChecked={(newValue) => setDc(newValue)}
              disabled={!props.chargingRequestFinished}
            />
            <CheckboxIndicator
              label="Zufahrtsbeschränkte ausblenden*"
              checked={props.filterSettings.get.reachability === "Unbeschrankt"}
              setChecked={(newValue) =>
                props.filterSettings.set((old) => ({
                  ...old,
                  reachability: newValue ? "Unbeschrankt" : "Beides",
                }))
              }
              disabled={!props.chargingRequestFinished}
              footnote
            />
            <CheckboxIndicator
              label="Nur freie"
              checked={props.filterSettings.get.occupancy === "Frei"}
              setChecked={(newValue) =>
                props.filterSettings.set((old) => ({
                  ...old,
                  occupancy: newValue ? "Frei" : "Beides",
                }))
              }
              disabled={!props.chargingRequestFinished}
            />
          </div>
          <div id="legendCheckboxFootnote">
            <span>
              *Zufahrtsbeschränkt&nbsp;(
              <svg
                width="10"
                height="10"
                viewBox="-24 -24 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="0" cy="0" r="23" fill="rgba(37, 130, 196, 0.75)" />
                <path d="M-12 -8L0 -14 L12 -8" strokeWidth="5" stroke="white" />
                <text
                  x="0"
                  y="16"
                  textAnchor="middle"
                  fontWeight="700"
                  fontSize="28"
                  fill="white"
                >
                  P
                </text>
              </svg>
              ): Ladesäule befindet sich hinter einer Schranke, z. B. in einem
              Parkhaus.
            </span>
          </div>
        </div>
      </div>
    </MapControl>
  );
}

function CheckboxIndicator(props: {
  label: string;
  checked: boolean;
  setChecked: (newValue: boolean) => void;
  disabled: boolean;
  footnote?: boolean;
}) {
  return (
    <label
      className={
        "legend__checkbox" +
        (props.disabled ? " legend__checkbox--disabled" : "") +
        (props.checked ? " legend__checkbox--checked" : "")
      }
    >
      <span className="legend__checkboxLable">{props.label}</span>
      <input
        type="checkbox"
        onChange={(e) => props.setChecked(!!e.target.checked)}
        checked={props.checked}
        disabled={props.disabled}
        aria-describedby={props.footnote ? "legendCheckboxFootnote" : undefined}
      />
      <svg
        className="legend__checkboxIndicator"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle className="legend__checkboxRing" cx="5" cy="5" r="4.5" />
        <circle className="legend__checkboxDot" cx="5" cy="5" r="2" />
      </svg>
    </label>
  );
}

export default Legend;
